function breakpoint(breakpoint)
{
  let breakpoints = {
    'xs': 0,
    'sm': 576,
    'md': 768,
    'lg': 992,
    'xl': 1200,
    'xxl': 2000,
    'screen': $(window).width(),
  }
  return breakpoints[breakpoint]
}

export { breakpoint }
